import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from 'src/common/dw_service';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DwGoogleApi {
  tenantid: number = 0;

  constructor(
    private http: HttpClient,
    private AS: ApiService,
  ) {}

  setTenant(_tenantid: number) {
    this.tenantid = _tenantid;
  }

  getTenant() {
    return this.tenantid
  }

  // ログサービスで本流ロジックに迷惑を掛けないため、即戻り＆エラーはスルー。
  sendlog(walletid: number = 0, type:string, v1:string="",v2:string="",v3:string="",v4:string="") {
    setTimeout(() => {
      try {
        this.sendlogImpl(walletid, type,v1,v2,v3,v4);
      } catch (ex) {
       console.log("gcp:sendLog:error:"+ex);
      }
    },1);
  }
  

  sendlogImpl(walletid: number, type:string, v1:string, v2:string, v3:string, v4:string) {
    let o = this;
    let app_id = environment.base.appname;
    let tm = (new Date()).getTime();
    let opt = ""; // 署名等
    var p = {
        ver:1,
        app_id:app_id,
        time:tm,
        wid: walletid,
        user: navigator.userAgent,
        opt:opt,
        type:type,
        v1:v1,
        v2:v2,
        v3:v3,
        v4:v4
      };
    o.execGCP(walletid, "pubsub", p);
  }


  execGCP(walletid: number, type: string, param: any) {
    const o = this;
    console.log(`***[dwGCP] type: ${type}, params : ${JSON.stringify(param)}`);
    o.getGcpToken().subscribe({
      next: (res: any) => {
        o._cxecGCP(type, walletid, res.Token, param).subscribe({
          next: (res) => {
            console.log(`***[dwGCP] Success to exec :${type}, res: ${JSON.stringify(res)}`);
          },
          error: (err) => {
            console.log(`***[dwGCP] Error. exec: ${type} : ${JSON.stringify(err)}`)
          }
        })
      },
      error:(error: any) => {
        console.log(`***[dwGCP] Error get token: ${error}`)
      }
    })
  }

  private _cxecGCP(type: string, walletId: number | string = 0, token: string, param: any):Observable<any> {
    const o = this;
    return o.sendPubSubMessage(walletId, token, param)
  }

  //トークン取得
  private getGcpToken():Observable<any> {
    const param: any = {
      // TenantID: Number(this.CL.tenantId) || environment.tenantid,
      TenantID: this.tenantid,
      scope: "pubsub"
    }
    return this.AS.exec("GET", null, "/EWA/Wallet/ExService/Gcp/Token", param)
  }

  private sendPubSubMessage(walletId: number | string, token: string, param: any):Observable<any> {
    const o = this;
    const topic = environment.pubsub.topic;
    const url = `https://pubsub.googleapis.com/v1/${topic}:publish`;
    const obs = new Observable(observer => {
      let obb = observer;
      let sz = JSON.stringify(param);
      let message = btoa(o.textToBinary(sz));
      let bodyStr = '{"messages":[{"data":"' + message + '"}]}';
      let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json;charset=UTF-8',});
      this.http.post(url, bodyStr, { headers: headers, observe: 'response'}).subscribe({
        next: (data: HttpResponse<any>) => {
          obb.next(data.body);
          obb.complete();
        },
        error: (err: HttpErrorResponse) => {
          obb.error(err);
          obb.complete();
        }
      })
    });
    return obs;
  }

  private textToBinary(text: string) {
    const textEncoder = new TextEncoder();
    const encodeString = (string: string) => textEncoder.encode(string);
    const decodeBinaryString = (uint8Array: Uint8Array) => uint8Array.reduce(
      (binaryString, uint8) => binaryString + String.fromCharCode(uint8),
      '',
    );
    return decodeBinaryString(encodeString(text));
  }

}

/*
ログ送信内容の取り決め

・来店スタンプ 
type: "event"
v1: "visit_point"
v2:1
v3:10 (トータルスタンプ数)
v4:

・ガチャ
type: "event"
v1: "gacha"
v2: 1 or 2  (ガチャのタイプ 1: qrガチャ、2: スタンプ交換ガチャ)
v3: A or B or uriageGacha 
v4: itemID

・クーポンもぎり
type: "event"
v1: "mogiri"
v2: 1 or 2  (ガチャのタイプ 1: qrガチャ、2: スタンプ交換ガチャ)
v3: A or B or uriageGacha 
v4: itemID


・仮会員登録完了
type: "event"
v1: "pre_register"
v2: {walletID}
v3:
v3:
v4:

・会員登録完了
type: "event"
v1: "register"
v2: {walletID}
v3: {personalInfoのJSON文字列} (生年月、性別)
v3:
v4:

・会員退会完了
type: "event"
v1: "withdrawal"
v2: {walletID}
v3: {personalInfoのJSON文字列} (生年月、性別)
v4:

・ログイン / ログアウト
type: "event"
v1: login or logout
v2: {walletID}
v3: {personalInfoのJSON文字列} (生年月、性別)
v4:

・お知らせ閲覧
type: "event"
v1: click_news
v2: {newsタイトル}
v3: {news URL}
v4:

・バナーリンクtype: 
"event"
v1: click_banner
v2: {バナーに設定された外部URL}
v3: 
v4:

・アプリ初回起動時
type: "event"
v1: app_start_up
v2:
v3: 
v4:

・アプリforeground / background
type: "event"
v1: app_foreground / app_background
v2:
v3: 
v4:

*/